import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InvoiceFilterBarComponent } from '../invoice-filter-bar/invoice-filter-bar.component';
import { MonthRange } from '../invoice-filter-bar/invoice-filter-bar.component';

@Component({
  selector: 'app-invoice-header',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, InvoiceFilterBarComponent],
  templateUrl: './invoice-header.component.html',
  styleUrl: './invoice-header.component.scss'
})
export class InvoiceHeaderComponent {
  @Input()  searchQuery  = '';
  @Input()  eventTypes: string[]    = [];
  @Input()  invoiceSiteNames: string[] = [];
  @Output() searchQueryChange     = new EventEmitter<string>();
  @Output() monthRangeChange      = new EventEmitter<MonthRange>();
  @Output() siteFilterChange      = new EventEmitter<string[]>();
  @Output() eventTypeFilterChange = new EventEmitter<string[]>();
}
